import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {z as r} from 'zod';

import {ShortLocaleNameEnum} from '../../provider/locale/locale-context-type';
import {useUser} from '../../provider/user/user-hook';
import {postAndDeserialize} from '../../util/api-adapter';

import {userUrl} from './user-const';

const userLanguageSchema = r.object({
    language: r.string(),
});

type UserLanguageType = r.infer<typeof userLanguageSchema>;

function updateUserLanguage(language: ShortLocaleNameEnum): Promise<UserLanguageType> {
    const url = `${userUrl}/language/`;

    return postAndDeserialize(url, userLanguageSchema, {language});
}

export function useUserLanguageMutation(): UseMutationResult<UserLanguageType, unknown, ShortLocaleNameEnum> {
    const {refetchUser} = useUser();

    return useMutation(updateUserLanguage, {
        onSuccess: refetchUser,
    });
}
